module.exports = __webpack_public_path__ + "static/media/blog-7.eba50d23.svg";